<script setup lang="ts">
/**
 * Singbac Incorporation (Pre) — FORM OF NOTICE (section 386AG(2)(a), Companies Act 1967)
 * "Notice to Controller". 원문 그대로 재현.
 * · registrable controller 마다 1부(패키지에서 DocScope ctrl_{id}/ 로 감쌈).
 * · 두 개의 "Your reply: Yes / No*" 는 controller 의 회신란 — 토글 아님, 평문 서식 그대로.
 * · (a) 개인 controller / (b) 법인 controller 세부는 [[변수]] → CddVarField (양쪽 모두 재현, 회신자가 해당란 작성).
 */
import CddVarField from './cdd/CddVarField.vue';
import SgIncPreSigners from './SgIncPreSigners.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-sec-title" style="text-align:center">
      FORM OF NOTICE MENTIONED IN SECTION 386AG(2)(a) OF COMPANIES ACT, 1967
    </div>

    <p class="doc-p">Date of notice: <CddVarField field-key="notice_date" label="Notice Date" /></p>
    <p class="doc-p">Dear <CddVarField field-key="controller_name" label="Controller Name" /></p>

    <p class="doc-p">
      We know or have reasonable grounds to believe that you are a registrable controller of
      <CddVarField field-key="company_name" label="Company Name" />
    </p>
    <p class="doc-p">
      This notice is sent under section 386AG(2)(a) of the Companies Act 1967 and requires you to provide the following
      information within 30 days after the date of this notice. Please send your reply by e-signing said notice. Failure
      to provide the information required by this notice may be an offence.
    </p>

    <p class="doc-p">
      1.&nbsp;&nbsp;Are you a registrable controller of <CddVarField field-key="company_name" label="Company Name" />?
    </p>
    <p class="doc-p indent">Your reply: Yes / No*</p>
    <p class="doc-p">
      *Delete as appropriate. If your reply is yes and you are an individual, please provide the particulars in
      sub-paragraph (a). If your reply is yes and you are a legal entity, please provide the particulars in
      sub-paragraph (b).
    </p>

    <p class="doc-p">
      (a)&nbsp;&nbsp;If your reply is yes and you are an individual, please provide the following particulars:
    </p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Name in full as stated in Passport or other ID</td>
          <td><CddVarField field-key="controller_full_name" label="Controller Full Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Aliases</td>
          <td><CddVarField field-key="controller_alias" label="Controller Aliases" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Permanent Residential Address</td>
          <td><CddVarField field-key="controller_residential_address" label="Controller Residential Address" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Passport No</td>
          <td><CddVarField field-key="controller_passport_no" label="Controller Passport No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">E-mail Address</td>
          <td><CddVarField field-key="controller_email" label="Controller E-mail Address" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Mobile Number</td>
          <td><CddVarField field-key="controller_mobile_no" label="Controller Mobile Number" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Nationality</td>
          <td><CddVarField field-key="controller_nationality" label="Controller Nationality" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">NRIC/FIN No.</td>
          <td><CddVarField field-key="controller_identification_no" label="Controller NRIC / FIN No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Date of Birth</td>
          <td><CddVarField field-key="controller_date_of_birth" label="Controller Date of Birth" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">
            Date on which you became an individual controller of
            <CddVarField field-key="company_name" label="Company Name" />
          </td>
          <td>
            <CddVarField
              field-key="controller_date_became_individual_controller"
              label="Date Became Individual Controller"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p">
      (b)&nbsp;&nbsp;If your reply is yes and you are a legal entity, please provide the following particulars:
    </p>
    <table class="cdd-tbl">
      <tbody>
        <tr>
          <td class="cdd-lcell">Name of the Company</td>
          <td><CddVarField field-key="controller_entity_name" label="Controller Entity Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Unique entity number issued by the Registrar, if any</td>
          <td><CddVarField field-key="controller_entity_uen" label="Controller Entity UEN" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Registered Office Address</td>
          <td><CddVarField field-key="controller_registered_office_address" label="Controller Registered Office Address" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Legal Form</td>
          <td><CddVarField field-key="controller_legal_form" label="Controller Legal Form" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">Jurisdiction where, and statute under which, you are Formed or Incorporated</td>
          <td><CddVarField field-key="controller_jurisdiction" label="Controller Jurisdiction" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">
            Name of the corporate entity register of the jurisdiction in which you are formed or incorporated, if
            applicable
          </td>
          <td><CddVarField field-key="controller_corporate_register_name" label="Controller Corporate Register Name" /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">
            Identification number or Registration number of the corporate entity register of the jurisdiction where you
            are formed or incorporated, if applicable
          </td>
          <td><CddVarField field-key="controller_corporate_register_no" label="Controller Corporate Register No." /></td>
        </tr>
        <tr>
          <td class="cdd-lcell">
            Date on which you became a corporate controller of
            <CddVarField field-key="company_name" label="Company Name" />
          </td>
          <td>
            <CddVarField
              field-key="controller_date_became_corporate_controller"
              label="Date Became Corporate Controller"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <p class="doc-p">
      2.&nbsp;&nbsp;Do you know or have reasonable grounds to believe that any other person is a registrable controller
      of <CddVarField field-key="company_name" label="Company Name" /> or is likely to have that knowledge?
    </p>
    <p class="doc-p indent">Your reply: Yes / No*</p>

    <p class="doc-p">In this notice &mdash;</p>
    <p class="doc-p">
      &ldquo;controller&rdquo;, &ldquo;corporate controller&rdquo;, &ldquo;individual controller&rdquo; and
      &ldquo;legal entity&rdquo; have the meanings given to them in section 386AB of the Companies Act 1967;
    </p>
    <p class="doc-p">
      &ldquo;identity card&rdquo; has the meaning given to it in section 2(1) of the National Registration Act 1965;
    </p>
    <p class="doc-p">
      &ldquo;registrable&rdquo; has the meaning given to it in section 386AC of the Companies Act 1967.
    </p>

    <p class="doc-p" style="margin-top:14px">Yours sincerely,</p>
    <p class="doc-p">No Signature Required</p>
    <p class="doc-p"><CddVarField field-key="director_name" label="Director Name" /></p>
    <p class="doc-p">Director</p>

    <div class="doc-sec-title" style="margin-top:20px">
      CONFIRMATION OF PARTICULARS BY REGISTRABLE CONTROLLER
    </div>
    <p class="doc-p">I the undersigned, hereby confirm that the particulars provided by me/us in this notice is:-</p>
    <p class="doc-p indent">(a) true and correct on item (1)*;</p>
    <p class="doc-p indent">(b) to my/our best knowledge, true and correct on item (2)*.</p>
    <p class="doc-p">
      I will update you, whenever there are changes to the particulars provided in this notice to enable you to keep the
      information in the Register of Registrable Controller up-to-date.
    </p>

    <!-- 서명 블록 [[Signers]] — 이 부수의 controller 본인(수동 추가/편집·T-Sign) -->
    <div class="sign-block">
      <div class="sign-lbl">Signature</div>
      <!-- 패널 생성과 같은 순서: 확인란 성명 → 없으면 컨트롤러 성명 (화면 = 문서) -->
      <SgIncPreSigners name-key="confirming_controller_name" fallback-name-key="controller_name" title="Controller/UBO" board-label="" />
    </div>
    <p class="doc-p">Controller/UBO</p>
    <p class="doc-p">Date: <CddVarField field-key="dated_on" label="Dated On" /></p>

    <div class="doc-attn"><p>* Delete as appropriate</p></div>
  </div>
</template>

<style scoped>
.indent { padding-left: 20px; }
.doc-attn p { margin: 0; }
.sign-block { margin-top: 12px; }
.sign-lbl { font-weight: 700; margin-bottom: 6px; }
</style>
